import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import AppHoc from "../../../../generics/AppHOC";
import TableView from "./TableView";

const [HbrCard] = reactWrapper(["hbr-card"]);
const TopClientsTable = (props) => {
    return (
        <div className="top-clients-table-wrapper">
            {props.tableStore && (
                <div className="clients-table">
                    <HbrCard className="report-clients-table">
                        <TableView {...props} />
                    </HbrCard>
                </div>
            )}
        </div>
    );
};

TopClientsTable.propTypes = {
    tableStore: PropTypes.object,
};

export default AppHoc(TopClientsTable);
